export const isValidPayroll = (value: string | null | undefined): boolean =>
  value != null && /^\d{6}$/.test(value);

export const isValidPayrollInput = (value: string): boolean => /^\d{0,6}$/.test(value);
